import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar  from '../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { FaUserPlus } from "react-icons/fa";
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";
// import { Base_Url, addEmployee } from '../../../../config/config';
import { Base_Url, addEmployee } from '../../../config/config';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const schema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    department: z.string().min(1, "Department is required"),
    phone: z.string().length(10, "Phone number must be 10 digits"),
    role: z.string().min(1, "Role is required"),
    company_name: z.string().min(1, "Company name is required")
});

const AddUser = () => {
    const token = localStorage.getItem('token');
    const naviagteToAllEmployee = useNavigate();
    const cus_id = localStorage.getItem('cus_id');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isToggleSidebar, isDarkMode } = useMyContext();
    const [roles, setRoles] = useState([
        { id: "PXROLE67e68d8fd9990", name: "Admin" },
        { id: "PXROLE67e68d8fd9991", name: "Manager" },
        { id: "PXROLE67e68d8fd9992", name: "Employee" }
    ]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            name: "",
            email: "",
            password: "",
            department: "",
            phone: "",
            role: "",
            company_name: ""
        }
    });

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (id === 'phone') {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
        }

        if (['name', 'department', 'company_name'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    const handleSelectChange = (selectedValues) => {
        if (selectedValues && selectedValues.length > 0) {
            setValue('role', selectedValues[0].id);
        }
    };

    const navigate = useNavigate();

    const naviagation = () => {
        navigate('/dashboard');
    }

    const onSubmit = async (data, event) => {
        const apiurl = Base_Url + addEmployee;
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                apiurl,
                data,
                {
                    headers: {
                        token,
                        'Content-Type': 'application/json',
                        cus_id: cus_id

                    }
                }
            );
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                naviagteToAllEmployee("/allEmployee");
                reset();
                setIsSubmitting(false);
            }
            else {
                toast.error(response.data.message?.email || response.data.message?.password);
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error(error || error?.email?.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div
                        className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }
                    >
                        <Sidebar />
                    </div>
                )}
                <div className={`p-4 md:p-6 min-h-[50vh] custom-scrollbar overflow-y-auto dark:bg-darkmodeColor ${isToggleSidebar ? 'ml-0' : 'mr-0'} ${isToggleSidebar ? 'w-full' : 'w-full'} mb-8 md:mb-0 `}>
                    <button onClick={naviagation}
                        className="flex justify-center w-full items-center hover:bg-purple-700 mb-6 bg-customPurple text-white px-4 py-2 rounded-md hover:bg-customPurple-dark transition duration-300">
                        <FaUserPlus className="text-3xl text-white mr-2" />
                        <h2 className="text-2xl font-bold text-center">Add New User</h2>
                    </button>
                    <form onSubmit={handleSubmit(onSubmit, onErrors)} className="dark:bg-darkmodeColor dark:text-white shadow-custom-light dark:shadow-custom-dark rounded-custom px-8 pt-6 pb-8 mb-4 font-sans">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label htmlFor="role" className="block text-sm font-bold mb-2">Select Role</label>
                                <Select
                                    options={roles}
                                    labelField="name"
                                    valueField="id"
                                    style={{
                                        padding: '0.5rem',
                                        appearance: 'none',
                                        borderRadius: '0.375rem',
                                        width: '100%',
                                        outline: '  ',
                                        backgroundColor: isDarkMode ? 'rgba(1, 14, 78, 0.96)' : '',
                                        color: isDarkMode ? 'white' : 'rgba(1, 14, 78, 0.96)',
                                    }}
                                    onChange={handleSelectChange}
                                />
                                {errors.role && <p className="text-red-500 text-xs italic">{errors.role.message}</p>}
                            </div>
                            <div>
                                <label className="block text-sm font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input className={`appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.company_name ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                   placeholder="Enter Name"
                                   type ="text"
                                   {...register('name')}
                                    onChange={handleInputChange}
                                />
                                {errors.name && <p className="text-red-500 text-xs italic">{errors.name.message}</p>}
                            </div>
                            <div>
                                <label className="block text-sm font-bold mb-2" htmlFor="company_name">
                                    Company Name
                                </label>
                                <input
                                    className={`appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.company_name ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                    id="company_name"
                                    type="text"
                                    placeholder="Enter company name"
                                    {...register('company_name')}
                                    onChange={handleInputChange}
                                />
                                {errors.company_name && <p className="text-red-500 text-xs italic">{errors.company_name.message}</p>}
                            </div>
                            <div>
                                <label className="block text-sm font-bold mb-2" htmlFor="email">
                                    Email
                                </label>
                                <input
                                    className={`appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.email ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                    id="email"
                                    type="email"
                                    placeholder="Enter email"
                                    {...register('email')}
                                />
                                {errors.email && <p className="text-red-500 text-xs italic">{errors.email.message}</p>}
                            </div>

                            <div className="relative">
                                <label className="block text-sm font-bold mb-2" htmlFor="password">
                                    Password
                                </label>
                                <input
                                    className={`appearance-none border w-full py-2 px-3 pr-10 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.password ? 'border-red-500' : ''
                                        } ${isDarkMode
                                            ? 'dark:bg-darkmodeColor text-white placeholder-white shadow-none'
                                            : ''
                                        }`}
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Enter password"
                                    {...register('password')}
                                />
                                <span
                                    className="absolute right-3 top-[38px] cursor-pointer text-gray-600 dark:text-white"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FiEyeOff /> : <FiEye />}
                                </span>
                                {errors.password && (
                                    <p className="text-red-500 text-xs italic">{errors.password.message}</p>
                                )}
                            </div>

                            <div>
                                <label className="block text-sm font-bold mb-2" htmlFor="department">
                                    Department
                                </label>
                                <input
                                    className={`appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.department ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                    id="department"
                                    type="text"
                                    placeholder="Enter department"
                                    {...register('department')}
                                    onChange={handleInputChange}
                                />
                                {errors.department && <p className="text-red-500 text-xs italic">{errors.department.message}</p>}
                            </div>

                            <div>
                                <label className="block text-sm font-bold mb-2" htmlFor="phone">
                                    Phone
                                </label>
                                <input
                                    className={`appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline shadow-custom-light rounded-custom ${errors.phone ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                    id="phone"
                                    type="tel"
                                    maxLength="10"
                                    placeholder="Enter 10 digit mobile no."
                                    {...register('phone')}
                                    onChange={handleInputChange}
                                />
                                {errors.phone && <p className="text-red-500 text-xs italic">{errors.phone.message}</p>}
                            </div>
                        </div>

                        <div className="flex items-center justify-center mt-6">
                            <button
                                className="bg-customPurple hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                type="submit"
                            >
                                {isSubmitting ? "Creating User..." : 'Create User'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};           

export default AddUser;